document.addEventListener("DOMContentLoaded", function () {
  const facades = document.querySelectorAll(".youtube-facade");

  facades.forEach(facade => {
    facade.addEventListener("click", function () {
      const videoId = this.getAttribute("data-id");
      this.innerHTML = `<iframe 
          src="https://www.youtube.com/embed/${videoId}?autoplay=1"
          frameborder="0" 
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen
          loading="lazy"
          width="560" height="315">
        </iframe>`;
    });
  });
});
